// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"frontend-common-styles-StageIntroductionModal__imageWrapper--NUXTX"};